import '@teliaee/design-system/styles/telia.css';
import '@teliaee/design-system/styles/global.css';
import './failures-map.scss';
import './tabs.scss';

import('bootstrap');
